import { axios } from '@/services/axios';

export const getNumber = async (numberId) => {
    const res = await axios.get(`/Number/${numberId}`);
    return res.data;
};
